module.exports = __webpack_public_path__ + "static/media/pallete.0a043073.jpg";